import politicasprivacidad from "@/assets/imgs/politicasprivacidad_img.png";
import { SEO } from "@/components/SEO/SEO";

export const PrivacyPage = () => {
  return (
    <section className="container my-5">
      <SEO
        title="Política de privacidad"
        description="Lee nuestra política de privacidad y términos de uso de OpenMatic."
        url="/privacy"
        noIndex={true}
      />
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 col-12 mb-md-0 p-md-4">
          <h5
            className="mt-0 inter-bold about-us-title-1"
            style={{ paddingBottom: "1.5rem" }}
          >
            Políticas de Privacidad
          </h5>
          <img
            className="card-image"
            src={politicasprivacidad}
            alt="about-us"
            width="400"
            height="490"
          />
        </div>

        <div className="col-md-8 p-2 ps-md-0">
          <div className="row" style={{ paddingTop: "5rem" }}></div>

          <p className="about-us-title text-start">
            Política de Privacidad de Open Matic Market
          </p>
          <p className="inter-regular about-us-text">
            I. Introducción Cuando utilizas OPEN MATIC MARKET, nos confías tus
            datos personales. Nos comprometemos a mantener esa confianza. Esto
            empieza por ayudarte a entender nuestras prácticas de privacidad. Te
            recomendamos que leas esta política para saber más sobre los datos
            personales que recopilamos, cómo se utilizan y comparten, y tus
            opciones con respecto a estos datos. El uso de las aplicaciones,
            sitios web, los productos u otros servicios que OPEN MATIC MARKET,
            pone a su disposición están sujetos en todo momento a nuestras
            Condiciones de Servicio, las cuales se incorporan en esta Política
            de Privacidad. Todos los términos que utilizamos en esta Política de
            Privacidad, y que no se hayan definido expresamente en los mismos,
            se entenderán definidas según sus usos naturales y obvios.
          </p>
          <p className="inter-regular about-us-text">
            II. Resumen A. Ámbito de aplicación Esta política describe OPEN
            MATIC MARKET y sus relacionadas recogen y utilizan los datos
            personales de nuestros clientes. Esta política se aplica a todos los
            usuarios de nuestras aplicaciones, sitios web, características u
            otros servicios en cualquier parte del mundo. Nuestras prácticas
            están sujetas a las leyes aplicables en los lugares que operamos.
            Esto significa que llevamos a cabo las prácticas descritas en esta
            política en un determinado país o región solamente si lo permite la
            legislación de esos lugares. Esta política también regula otras
            recopilaciones de datos personales de OPEN MATIC MARKET, en relación
            con sus servicios. Por ejemplo, podemos recopilar la información de
            contacto de los propietarios o empleados de las tiendas u otros
            comerciantes. Todas las personas sujetas a esta política se
            denominan “usuarios” en esta política. B. Responsable de datos y
            transferencia Open Matic SpA es el responsable de los Datos
            Personales recolectados en relación con el acceso o uso de los
            servicios y la plataforma. Preguntas, comentarios y quejas sobre las
            prácticas de uso de datos de OPEN MATIC MARKET pueden enviarse al
            siguiente correo electrónico privacy@openmaticmarket.com III.
            Recolección de datos y su uso
          </p>

          <p className="inter-regular about-us-text">
            A. Fuentes de datos personales Los siguientes datos personales son
            recolectados por OPEN MATIC MARKET o en su nombre: A.1. Datos
            proporcionados por los usuarios. Esto incluye: • cuando los usuarios
            nos proporcionan dicha información directamente, y • cuando los
            datos personales de los usuarios se recogen automáticamente en
            relación con el acceso o el uso de los servicios, cuando los
            usuarios utilizan nuestra Plataforma. A.2. Datos facilitados por
            nuestras subsidiarias y afiliados. • cuando nos proporcionan datos
            personales sobre los usuarios. Por ejemplo, cuando los usuarios
            compran artículos...
          </p>

          <div className="container-fluid mx-0">
            {/* <div className="row">
              <div className="col-6 font16 inter-regular text-black-50">
                <div className="d-flex align-items-center">
                  <span>Cantidad</span>
                </div>
              </div>
            </div> */}
            {/* <hr /> */}
          </div>
          <div className="container-fluid ">
            <div className="row">
              <div className="col d-flex justify-content-start"></div>
            </div>
          </div>
        </div>

        {/* <div className="col-md-2"></div> */}
      </div>
      {/* <div className="row-cols-3 container">
        <div className="col-12">
          <div className="border border-1 rounded p-4">
            <div className="row">
              <div className="col-6">
                <h5 className="about-us-details">Misión</h5>
              </div>
              <div className="col-6">
                <h5 className="about-us-details">Visión</h5>
              </div>

              <hr />
            </div>

            <div className="row">
              <div className="col-6 about-us-col-6">
                <p>
                  Entregar soluciones innovadoras de entrega automática de
                  productos para nuestros clientes, integrando tecnologías que
                  otorguen una buena relación costo-beneficio, de modo tal que
                  la incorporación de ellas en sus actividades sean una
                  verdadera oportunidad de negocio.
                </p>
              </div>
              <div className="col-6 about-us-col-6">
                <p>
                  OPEN MATIC aspira a ser un socio estratégico e innovador,
                  aportando siempre soluciones integrales para el desarrollo de
                  sus proyectos y participando activamente en el crecimiento de
                  sus negocios como un nuevo canal de ventas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};
